import { useMessageServiceChannelDetailQuery } from "features/MessagingChannel/hooks";
import { useNetworkRelationDetailQuery } from "features/RecordTarget/hooks";
import { useUserDetailQuery } from "features/User/hooks";
import { snakeCase } from "lodash";
import { MessageServiceChannel } from "models/integration/messageService";
import { UserRole } from "features/User/models";
import { titleize } from "helpers/string";

type EnabledOption = {
  enabled: boolean
};

type TargetNameArgs = {
  resourceId: MessageServiceChannel["id"]      ;
  resourceType: "MessageServiceChannel" | "User" | "OnboardingJourneyNetworkRelation";
  options?: EnabledOption;
  includeChannelHash?: boolean;
  loadingLabel?: string | null;
};

export default function useTargetName({
  resourceId,
  resourceType,
  includeChannelHash = false,
  options = { enabled: true },
  loadingLabel = "Loading"
}: TargetNameArgs) {
  const { data: userData } = useUserDetailQuery(resourceId || "", {
    enabled: resourceType === "User" && !!resourceId && !!options.enabled,
  });
  const { data: relationData } = useNetworkRelationDetailQuery(resourceId || "", {
    enabled: resourceType === "OnboardingJourneyNetworkRelation" && !!resourceId && !!options.enabled,
  });
  const { data: channelData } = useMessageServiceChannelDetailQuery(resourceId || "", {
    enabled: resourceType === "MessageServiceChannel" && !!resourceId && !!options.enabled,
  });
  if (resourceType === "User" && userData) {
    return { name: userData?.fullName };
  } else if (resourceType === "OnboardingJourneyNetworkRelation" && relationData) {
    return { name: titleize(relationData.name), role: snakeCase(relationData.name) as UserRole };
  } else if (resourceType === "MessageServiceChannel" && channelData) {
    return { name: `${includeChannelHash ? "# " : ""}${titleize(channelData.name)}` };
  } else if (resourceType && !resourceId) {
    return { name: "Unassigned" };
  }
  return { name: options.enabled ? loadingLabel : "" };
}
